var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{attrs:{"disabled":_vm.isDisabled}},_vm._l((_vm.item.sections),function(child,i){return _c('layout-section',{key:child.id,attrs:{"activeID":_vm.activeID,"item":child,"index":i}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }